export * from '@lazy-cjk/zh-convert-table/table';
import m from '@lazy-cjk/zh-convert-table/table';

export default m;
